/**
 * Created by hao.cheng on 2017/5/7.
 */
import React from 'react';
import CkPage from "../../components/CkPage";
import styled from "styled-components";
import {Button} from "antd";
import Iconfont from "../../components/Iconfont/Iconfont";


const AMFContent = styled.div`
    // background-color: #fff;
    // padding: 20px 15px;
    // height:calc(100vh - 80px);
    
    display: flex;
    justify-content: center;
    flex-direction: column;
    >div{
      text-align: center;
    }
    .amf-title{
      font-size: 16px;
      color: #959595;
      margin-bottom: 20px;
    }
    .amf-icon{
      font-size: 146px;
      opacity: .7;
    }
    .amf-tools{
        >button{
          font-size: 14px;
          
        }
    }
    
`

class SigninWallGuidePage extends React.Component {
    state = {
        animated: ''
    };

    render() {
        const ckPageContent = <div style={{backgroundColor:'#fff',padding:16}}>
            <div>
                <div style={{display:'flex',alignItems:'center'}}>
                    <Iconfont style={{fontSize:30,color:'#EC6A59'}}  libname="ckicon" type="shuzisucai3"/>
                    <span style={{fontSize:14,margin:'0 10px'}}>该服务需要高级会员权限，请去</span>
                    <Button  type="primary" ghost  onClick={()=>{
                    this.props.router.push("/admin/mall/products");
                }}>商城购买</Button>
                </div>
                <img style={{marginLeft:49}} src="https://img.qdj8.cn/wall-bg1.jpg" alt=""/>
            </div>
            <div>
                <div style={{display:'flex',alignItems:'center'}}>
                    <Iconfont style={{fontSize:30,color:'#9CBC23'}}  libname="ckicon" type="shuzisucai4"/>
                    <span style={{fontSize:14,margin:'0 10px'}}>签到墙服务，需要在PC端进行简单设置。</span>
                </div>
                <img style={{marginLeft:49}} src="https://img.qdj8.cn/wall-bg2.jpg" alt=""/>
            </div>
            <div>
                <div style={{display:'flex',alignItems:'center'}}>
                    <Iconfont style={{fontSize:30,color:'#68C4D4'}}  libname="ckicon" type="shuzisucai5"/>
                    <span style={{fontSize:14,margin:'0 10px'}}>启动签到墙生成的动态效果（以下为视频展示）</span>
                </div>
                <a href="https://www.bilibili.com/video/av22342147/?spm_id_from=333.23.home_video_list.1" target="_Blank">
                    <img style={{marginLeft:49}} src="https://img.qdj8.cn/wall-bg3.jpg" alt=""/>
                </a>
            </div>
        </div>

        return (
            <CkPage title={null} content={ckPageContent}/>
        )
    }
}

export default SigninWallGuidePage;


// WEBPACK FOOTER //
// ./src/containers/interact/SigninWallGuidePage.jsx